// @flow
import type {Action} from '../../lib/definitions/redux'
import type {Creditor} from '../../lib/definitions/swagger'
import * as actions from '../actions/payment'
import Immutable from 'seamless-immutable'

export type PaymentState = {
	payees: Array<Creditor>
}


const initialState : Immutable<PaymentState> = Immutable({
	payees: []
})

export default function (state : Immutable<PaymentState> = initialState, action : Action) : PaymentState{
	switch(action.type){
		case actions.PAYMENT_GET_PAYEES:
			return state.set('payees', action.payees)

	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/payment.js